import { render, staticRenderFns } from "./AssignMultipleJobSection.vue?vue&type=template&id=60644378&"
import script from "./AssignMultipleJobSection.vue?vue&type=script&lang=js&"
export * from "./AssignMultipleJobSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports